import { render, staticRenderFns } from "./modalEditProduct.vue?vue&type=template&id=4d1492f2&"
import script from "./modalEditProduct.vue?vue&type=script&lang=js&"
export * from "./modalEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports